import styled from 'styled-components';

export const FormGroup = styled.div`
    margin-bottom: 3px;
`;

export const Row = styled.div.attrs({className:'row'})`
    margin-right: -15px;
    margin-left: -15px;
    display: ${props => props.isInvisible?'none':'block'};
    margin-top: ${props => props.margen_arriba?props.margen_arriba:0}px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:0}px;
`;

export const ContenedorForm = styled.div`    
    position: absolute;
    background-color: white;
    width: ${props => props.porc_ancho?props.porc_ancho:60}%;
    border: 1px solid #cfd8dc;
    margin-left: ${props => props.porc_ancho?(100-props.porc_ancho)/2:20}%;
    margin-right: ${props => props.porc_ancho?(100-props.porc_ancho)/2:20}%;
    margin-bottom: 20px;    
    padding-bottom: 10px;
    @media (max-width: 767px) {	    
        margin-left: 1%;
        margin-right: 1%;
        width: 98%;
    }
`;

export const HeaderForm = styled.div`
    height: 25px;
    background-color: #eceff1;    
    border-bottom: 1px solid #cfd8dc;
    padding: 0.2rem 1.25rem;
`;

export const CuerpoForm = styled.div`
    padding-bottom: 10px;
    padding-top: 0;
    padding-left: 10px;
    padding-right: 10px;      
    margin: 0;
`;

export const TituloForm = styled.p`
    font-size: 12px;
    font-weight: 700;
    display: inline;    
`;

export const SubTituloForm = styled.p`
    font-size: 11px;
    font-weight: 600;
    display: inline;
`;

export const ContainerEdit = styled.div`    
    border-bottom: 1px solid #cfd8dc;
    height: ${props => props.alto?props.alto:70}px;
    padding: 10px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:15}px;
`;

export const ContenedorBoton = styled.div`
    margin-top: ${props => props.margen_arriba?props.margen_arriba:10}px;
    @media (max-width: 991px) {
        margin-top: 0px;
    }
`;

export const ContainerCol = styled.div`
    margin-top: ${props => props.margen_arriba?props.margen_arriba:0}px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:1}px;
    display: ${props => props.isInvisible?'none':'block'};
    text-align: ${props => props.align?props.align:'left'}; 
    padding-right: ${props => props.margen_der?props.margen_der:'15'}px;     
`;


export const ContenedorToggle = styled.span`
  margin-left: 15px;
`;